/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_NewInputs */

const cs_enum_new = /** @type {(inputs: Enum_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový`)
};

const en_enum_new = /** @type {(inputs: Enum_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Enum_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_new = /** @type {((inputs?: Enum_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_new(inputs)
	return cs_enum_new(inputs)
});